// PowerSync — реактивный список материалов пользователя.
//
// Чтение через `usePowerSyncQuery` (локальная SQLite), без tRPC. Записи попадают
// в SQLite через PowerSync sync stream `user_materials` (sync-rules.yaml).
//
// LocalMaterial — РЕАЛЬНЫЕ колонки БД (information_schema). Трансляция в
// стабильный UI-DTO — в `components/materials/_api.ts`.
import { usePowerSyncQuery } from "@/lib/powersync/use-query";

export interface LocalMaterial {
	id: string;
	user_id: string;
	name: string;
	type: string; // enum material_type
	mime_type: string | null;
	file_size_bytes: number | null;
	original_file: string | null;
	content: string | null;
	transcription: string | null;
	notes: string | null;
	duration: number | null;
	favorite: number; // bool 0/1
	tags: string | null; // ARRAY → JSON-строка
	view_count: number | null;
	youtube_thumbnail: string | null;
	processing_status: string;
	error_message: string | null;
	share_token: string | null;
	thumb_hash_base64: string | null;
	thumbnail_url: string | null;
	detected_language: string | null;
	language: string | null;
	/** NULL = обычный материал; 'tutor_chat' = derived-материал диалога. */
	source_kind: string | null;
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
}

export function useMaterialsQuery(userId: string | undefined) {
	// РЕШЕНИЕ(create-from-chat): derived-материал чата — первоклассный видимый
	// материал (откат скрытия). Раньше стоял `AND source_kind IS NULL`,
	// прятавший derived-материалы диалога из browse-списка — это было ошибкой.
	return usePowerSyncQuery<LocalMaterial>(
		`SELECT * FROM materials
		   WHERE user_id = ? AND deleted_at IS NULL
		ORDER BY updated_at DESC`,
		[userId ?? ""],
	);
}

export function useMaterialByIdQuery(id: string | undefined) {
	return usePowerSyncQuery<LocalMaterial>(
		`SELECT * FROM materials WHERE id = ? AND deleted_at IS NULL`,
		[id ?? ""],
	);
}

export function useMaterialsBySetQuery(setId: string | undefined) {
	// Связь материал↔сет — через полиморфный set_items (item_type='material';
	// нет колонки set_id в materials).
	return usePowerSyncQuery<LocalMaterial>(
		`SELECT m.* FROM materials m
		   JOIN set_items i ON i.item_id = m.id AND i.item_type = 'material'
		  WHERE i.folder_id = ? AND m.deleted_at IS NULL
		ORDER BY m.updated_at DESC`,
		[setId ?? ""],
	);
}
